import { useCallback } from 'react';

import { useToast } from '@/components/feedback/toast';
import { ApiError } from '@/lib/api/errors';

import { AUTH_ERROR_CODES } from './constants';
import { authErrorMessage } from './error-copy';

/**
 * Returns a `notify(error)` that surfaces an auth failure as a dark toast.
 * Account-lockout is intentionally skipped — it's shown by the sticky toast in
 * `useLockoutNotice`, so we don't double-notify. Centralizes the catch→toast
 * block that every auth screen would otherwise repeat.
 */
export function useAuthErrorToast() {
  const toast = useToast();
  return useCallback(
    (error: unknown) => {
      if (error instanceof ApiError && error.code === AUTH_ERROR_CODES.ACCOUNT_TEMPORARILY_LOCKED) {
        return;
      }
      toast.warning({ title: authErrorMessage(error) });
    },
    [toast],
  );
}
